































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { validationMixin } from 'vuelidate';
import Vuelidate from 'vuelidate';
import { required, integer, requiredIf, minLength, between } from 'vuelidate/lib/validators';
import secondaryNav from '@/components/navbars/secondary-nav.vue';

import {
	ProductsApi,
	Product,
	JobsApi,
	Job,
	TransceiversApi,
	SensorsApi,
	VatsApi,
	Vat,
} from '@/api';
import ChartAdmin from '@/components/charts/chart-admin.vue';
import Toast from '@/components/display/toast.vue';
import { ParsingUtil } from '@/common/ParsingUtil';

@Component({
	components: {
		secondaryNav,
		ChartAdmin,
		Toast,
	},
	validations: {
		vats: {
			$each: {
				formula: { required },
				sizeString: { required },
				vatOffset: { required, between: between(-1000, 1000) },
				emptyDistance: { required, integer, between: between(0, 6000) },
				stirrerThresh: { between: between(0, 1000) },
			},
		},
	},
	mixins: [validationMixin],
})
export default class VatUpdate extends Vue {
	public loading = false;
	public submitStatus: 'ERROR' | 'PENDING' | 'OK' | null = null;
	public vatCount = 2;
	public product: Product | null = null;
	public vats = [];
	public vatId: any[] | null = null;
	public vatId2: any[] | null = null;
	public vatId3: any[] | null = null;

	public vat1Sensors;
	public vat2Sensors;
	public vat3Sensors;
	public vatStateOptions = [
		{ value: 'notUsed', text: 'Not In Use' },
		{ value: 'nonSupply', text: 'Non-Supply' },
		{ value: 'supply', text: 'Supply' },
	];

	public options = [
		{ value: 'FonterraVatII', text: 'Fonterra Vat II' },
		{ value: 'Butterfly', text: 'Butterfly' },
		{ value: 'Longveld', text: 'Longveld' },
		{ value: 'Spherical', text: 'Spherical' },
		{ value: 'Crown', text: 'Crown' },
	];

	public optionSizes = {
		FonterraVatII: [
			{ value: '2000', text: '2000' },
			{ value: '2300', text: '2300' },
			{ value: '3400', text: '3400' },
			{ value: '4100', text: '4100' },
			{ value: '4500', text: '4500' },
			{ value: '5700', text: '5700' },
			{ value: '6800', text: '6800' },
			{ value: '7800', text: '7800' },
			{ value: '9100', text: '9100' },
			{ value: '11000', text: '11000' },
			{ value: '11500W', text: '11500W' },
			{ value: '12000', text: '12000' },
			{ value: '14000', text: '14000' },
			{ value: '14000W', text: '14000W' },
			{ value: '15000', text: '15000' },
			{ value: '16000', text: '16000' },
			{ value: '16000W', text: '16000W' },
			{ value: '18000', text: '18000' },
			{ value: '18000W', text: '18000W' },
			{ value: '21500W', text: '21500W' },
			{ value: '24500W', text: '24500W' },
			{ value: '26500W', text: '26500W' },
			{ value: '30000W', text: '30000W' },
		],
		Butterfly: [
			{ value: '1050', text: '1050' },
			{ value: '1700', text: '1700' },
			{ value: '2250', text: '2250' },
			{ value: '2700', text: '2700' },
			{ value: '2700Cummings', text: '2700 Cummings' },
			{ value: '3400', text: '3400' },
			{ value: '3400Winiata', text: '3400 Winiata' },
			{ value: '3400KMOrganics', text: '3400 KM Organics' },
			{ value: '3700', text: '3700' },
			{ value: '3700DargavilleOrganics', text: '3700 Dargaville Organics' },
			{ value: '4100', text: '4100' },
			{ value: '4500', text: '4500' },
			{ value: '4500TawaRidge', text: '4500 Tawa Ridge' },
			{ value: '5700', text: '5700' },
			{ value: '6800', text: '6800' },
			{ value: '9100', text: '9100' },
		],
		Longveld: [
			{ value: '5400', text: '5400' },
			{ value: '7500', text: '7500' },
			{ value: '9400', text: '9400' },
			{ value: '11400', text: '11400' },
			{ value: '21000', text: '21000' },
			{ value: '29000', text: '29000' },
		],
		Spherical: [
			{ value: '10000', text: '10000' },
			{ value: '14000', text: '14000' },
			{ value: '24500', text: '24500' },
			{ value: '31000', text: '31000' },
		],
		Crown: [{ value: '22000', text: '22000' }],
	};
	private api: ProductsApi;

	constructor() {
		super();
		this.api = new ProductsApi();
	}

	public stepValidate(name: string) {
		return async () => {
			const form = this.$v[name];
			form.$touch();
			return !form.$invalid;
		};
	}

	public setDefault(vat: any) {
		vat.emptyDistance =
			parseInt(this.getHeight(vat.formula, vat.sizeString.toString()), 10) +
			parseInt(vat.vatOffset, 10);
	}

	public created() {
		this.load();
	}

	public async load() {
		const productId: number | null = ParsingUtil.parseId(this.$route.params.productId);
		if (productId == null) return;
		this.loading = true;
		try {
			const { data } = await this.api.getProductById(productId, {
				params: {
					include: 'vats,org',
				},
			});
			this.product = data;
			this.vats = data.vats || [];
			this.org = data.org || {};
		} catch (e) {
			console.log(e);
			this.product = null;
		} finally {
			this.loading = false;
		}
	}

	public async onSubmit(e: Event) {
		e.preventDefault();
		this.$v.$touch();
		if (this.$v.$invalid) {
			this.submitStatus = 'ERROR';
			return;
		}
		this.submitStatus = 'PENDING';
		const { productId } = this.$route.params;
		const product: Product = {};
		product.vats = [];
		this.vats.map(vat =>
			product.vats.push({
				vatId: vat.id,
				formula: vat.formula,
				vatType: vat.formula,
				vatSize: vat.sizeString,
				offset: vat.vatOffset,
				emptyDistance: vat.emptyDistance,
				stirrerThresh: vat.stirrerThresh,
				state: vat.state,
			}),
		);

		try {
			const response = await new ProductsApi().productVatsetup(parseInt(productId, 10), {
				data: product,
			});
			// console.log(response);
		} catch (e) {
			const error = e.response.data.errors.name[0];
			new Toast().makeToast(error, 'Error Signing Off', 'danger', true);
			this.submitStatus = 'ERROR';
			return;
		}

		new Toast().makeToast('Successfully Updated Vats', 'Successful Allocation', 'success');

		setTimeout(() => {
			this.submitStatus = 'OK';
			// this.$router.push({ name: 'products.list' });
			this.$router.push({ name: 'products.milk.view', params: { productId } });
		}, 1000);
	}

	public getHeight(type: string, size: string) {
		let height;
		switch (type) {
			case 'Butterfly':
				switch (size) {
					case '1050':
						height = 610;
						break;
					case '1700':
						height = 915;
						break;
					case '2250':
						height = 1175;
						break;
					case '2700':
						height = 1420;
						break;
					case '2700Cummings':
						height = 1420;
						break;
					case '3400':
						height = 1465;
						break;
					case '3400Winiata':
						height = 1465;
						break;
					case '3400KMOrganics':
						height = 1465;
						break;
					case '3700':
						height = 1465;
						break;
					case '3700DargavilleOrganics':
						height = 1465;
						break;
					case '4100':
						height = 1595;
						break;
					case '4500':
						height = 1760;
						break;
					case '4500TawaRidge':
						height = 1760;
						break;
					case '5700':
						height = 2170;
						break;
					case '6800':
						height = 2565;
						break;
					case '9100':
						height = 3395;
						break;
				}
				break;
			case 'Crown':
				switch (size) {
					case '22000':
						height = 0;
						break;
				}
				break;
			case 'Longveld':
				switch (size) {
					case '5400':
						height = 1500;
						break;
					case '7500':
						height = 2000;
						break;
					case '9400':
						height = 2440;
						break;
					case '11400':
						height = 2100;
						break;
					case '21000':
						height = 3520;
						break;
					case '29000':
						height = 4628;
						break;
				}
				break;
			case 'Spherical':
				switch (size) {
					case '10000':
						height = 2673;
						break;
					case '14000':
						height = 2990;
						break;
					case '24500':
						height = 3600;
						break;
					case '31000':
						height = 3900;
						break;
				}
				break;
			case 'FonterraVatII':
				switch (size) {
					case '2000':
						height = 2022;
						break;
					case '2300':
						height = 1099;
						break;
					case '3400':
						height = 1260;
						break;
					case '4100':
						height = 1493;
						break;
					case '4500':
						height = 1034;
						break;
					case '5700':
						height = 1338;
						break;
					case '6800':
						height = 1607;
						break;
					case '7800':
						height = 1817;
						break;
					case '9100':
						height = 2251;
						break;
					case '11000':
						height = 2562;
						break;
					case '11500W':
						height = 1794;
						break;
					case '12000':
						height = 2837;
						break;
					case '14000':
						height = 3312;
						break;
					case '14000W':
						height = 2232;
						break;
					case '15000':
						height = 3650;
						break;
					case '16000':
						height = 3750;
						break;
					case '16000W':
						height = 2518;
						break;
					case '18000':
						height = 4360;
						break;
					case '18000W':
						height = 2930;
						break;
					case '21500W':
						height = 3300;
						break;
					case '24500W':
						height = 3738;
						break;
					case '26500W':
						height = 4043;
						break;
					case '30000W':
						height = 4823;
						break;
				}
				break;
		}
		return height;
	}
}
